import { matchPath } from 'react-router-dom';
import config from 'util/config';

const MAP_LINKS = {
  taskProject: {
    old: '/WS:alias/projects/:projectId/tasks/:taskId',
    new: '/WS:alias/projects/:projectId?modal=task-view&taskId=:taskId',
    withComment: '/WS:alias/projects/:projectId?modal=task-view&taskId=:taskId&commentId=:commentId',
  },
  taskCommon: {
    old: '/WS:alias/tasks/:taskId',
    new: '/WS:alias/tasks?modal=task-view&taskId=:taskId',
    withComment: '/WS:alias/tasks?modal=task-view&taskId=:taskId&commentId=:commentId',
  },
  project: {
    old: '/WS:alias/projects/:projectId',
    new: '/WS:alias/projects/:projectId',
  },
  billing: {
    old: '/WS:alias/settings/rate',
    new: '/WS:alias/settings?section=rate',
  },
};

const mathPathname = (path) => {
  return window.location.pathname.indexOf('/WS') !== -1
    ? matchPath(window.location.pathname, { path })
    : matchPath(window.location.pathname, { path: path.replace('/WS:alias', '') });
};

const redirect = (path) => {
  window.location.href = config.newAppUrl + path;
};

const redirectManager = (alias) => {
  const commentId = Number(window.location.hash.replace('#comment-', ''));

  const matchTaskProject = mathPathname(MAP_LINKS.taskProject.old);
  if (matchTaskProject && !!commentId) {
    redirect(
      MAP_LINKS.taskProject.withComment
        .replace(':alias', matchTaskProject.params.alias ?? alias)
        .replace(':projectId', matchTaskProject.params.projectId)
        .replace(':taskId', matchTaskProject.params.taskId)
        .replace(':commentId', commentId.toString()),
    );
    return;
  }

  if (matchTaskProject && !commentId) {
    redirect(
      MAP_LINKS.taskProject.new
        .replace(':alias', matchTaskProject.params.alias ?? alias)
        .replace(':projectId', matchTaskProject.params.projectId)
        .replace(':taskId', matchTaskProject.params.taskId),
    );
    return;
  }

  const matchTaskCommon = mathPathname(MAP_LINKS.taskCommon.old);
  if (matchTaskCommon && !!commentId) {
    redirect(
      MAP_LINKS.taskCommon.withComment
        .replace(':alias', matchTaskCommon.params.alias ?? alias)
        .replace(':projectId', matchTaskCommon.params.projectId)
        .replace(':taskId', matchTaskCommon.params.taskId)
        .replace(':commentId', commentId.toString()),
    );
    return;
  }

  if (matchTaskCommon && !commentId) {
    redirect(
      MAP_LINKS.taskCommon.new
        .replace(':alias', matchTaskCommon.params.alias ?? alias)
        .replace(':projectId', matchTaskCommon.params.projectId)
        .replace(':taskId', matchTaskCommon.params.taskId),
    );
    return;
  }

  const matchProject = mathPathname(MAP_LINKS.project.old);
  if (matchProject) {
    redirect(
      MAP_LINKS.project.new
        .replace(':alias', matchProject.params.alias ?? alias)
        .replace(':projectId', matchProject.params.projectId),
    );
    return;
  }

  const mathBilling = mathPathname(MAP_LINKS.billing.old);
  if (mathBilling) {
    redirect(MAP_LINKS.billing.new.replace(':alias', mathBilling.params.alias ?? alias));
  }
};

export default redirectManager;
